import {Form, FormInstance, Input, Modal} from 'antd';
import { useState } from 'react';

export interface ModalTypes {
  visible: boolean;
  useInfo: any;
  handleValue: (val: any,form:FormInstance<any>) => void;
  handleCancel: () => void;
}

const ChangePassword = (props: ModalTypes) => {
  const [hasError, setError] = useState<boolean>(false);
  const { useInfo, visible, handleCancel, handleValue } = props;
  const [form] = Form.useForm();
  const handleOk = () => {
    form.submit();
    if (hasError) return;
    const values = form.getFieldsValue();
    form.resetFields();
    handleValue(values,form);
  };
  return (
    <Modal open={visible} title="修改密码" onOk={handleOk} onCancel={handleCancel}>
      <Form form={form} labelCol={{ span: 4 }} onFinishFailed={() => setError(true)}>
        <Form.Item label="用户名">
          {useInfo?.account}
        </Form.Item>
        <Form.Item
          label="新密码"
          name="password"
          rules={[{ required: true, message: '请输入新密码' }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export { ChangePassword };
